<!--
 * @Author: 张天昊
 * @Date: 2024-11-13 10:47:40
 * @LastEditTime: 2024-11-15 14:39:27
 * @LastEditors: 张天昊
 * @Description: 
 * @FilePath: /Mobile/src/pages/index/components/PrivacyInfoBody.vue
-->
<!-- 主体部分预定须知菜单选择标题 -->
<template>
  <div>
    <div class="body-container" v-on:click="nextUrl(infoItem)">
      <div class="body_inner">
        <div class="body-left">
          <div>{{ infoItem.name }}</div>
        </div>
        <div class="body-right">
          <div>
            <img src="@/assets/index/ic_right_arrow_common.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="lineDiv" v-if="showLine">
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PirvacyInfoBody',
  props: {
    infoItem: Object,
    showLine: Boolean
  },
  methods: {
    nextUrl: function (infoItem) {
      this.$router.push({
        name: 'PersonalInformationCollectionDetail',
        query: { keyName: infoItem.key }
      });
    }
  }
};
</script>

<style scoped lang="less">
.body-container {
  width: 100%;
  height: 64px;
  margin-bottom: 1px;
}

.body_inner {
  height: 100%;
  margin-left: 16px;
  margin-right: 16px;
}

.body-left {
  position: absolute;
  margin-top: 26px;
  height: 16px;
  font-size: 16px;
  line-height: 16px;
  color: rgb(51, 51, 51);
  letter-spacing: 0px;
  font-family: PingFangSC-Regular, sans-serif;
}
.body-right {
  height: 100%;
  float: right;
  width: 12px;
  height: 12px;
  position: relative;
  margin-top: 28px;
}
.body-right div img {
  width: 12px;
  height: 12px;
  position: absolute;
}
.lineDiv {
  position: relative;
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 2px;
  margin-bottom: 2px;
  // background-color: rgb(168, 50, 50);
  // height: 2px;
}
.line {
  height: 0.5px;
  width: 100%;
  background-color: rgb(238, 238, 238);
}
</style>
